<template>
    <z-basePage :title="'结算记录'">
        <div class="search-top">
            <span>BU名称</span>
            <el-select class="top-choose" v-model="buId" @change="changeBu">
                <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                </z-limitOption>
            </el-select>
            
            <span>年份</span>
            <el-select class="top-choose" v-model="year" clearable>
                <el-option v-for="item in bonusYearOptions" :key="item" :value="item" :label="item">
                </el-option>
            </el-select>
            
            <span>周期</span>
            <el-select class="top-choose" v-model="cycleId" clearable>
                <el-option v-for="item in bonusCycleOptions" :key="item.id" :label="item.cycle_number_show" :value="item.id">
                </el-option>
            </el-select>

            <div class="back-btn blue shift" @click="search()">查询</div>
            <div class="back-btn" @click="downloadExcel" v-if='false'>导出excel</div>
        </div>

        <div class="back-list search">
            <div class="list-head">
                <div>奖金周期</div>
                <div>结算时间</div>
                <div>BU名称</div>
                <div>姓名</div>
                <div>工号</div>
                <div>结算金额(元)</div>
                <div>结算详情</div>
            </div>
            <z-scrollDiv class='main'>
                <div v-for="(item,index) in datalist" :key="item.id">
                    <div class="list-item">
                        <div>{{ item.cycle_disp }}</div>
                        <div>{{ item.confirm_time | placeholder }}</div>
                        <div class="overhide" :title="item.bu_name">{{ item.bu_name }}</div>
                        <div class="overhide" :title="item.real_name">{{ item.real_name }}</div>
                        <div>{{ item.user_name }}</div>
                        <div>{{ item.confirm_money }}</div>
                        <div>
                            <span class="blue" @click="showBill(item,index)">{{ bill_index === index?"收起":"展开" }}</span>
                        </div>
                    </div>
                    <bill class="table" :class="{active:bill_index === index}"  :data="bill_data"></bill>
                </div>
                <z-noData :list="datalist"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="search"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>


    </z-basePage>
</template>

<script>
    import bill from 'src/components/bill.vue'
    import { mapState,mapGetters } from "vuex"
    import { getBonusCycleOptions } from "src/control/common.js";


    export default {
        components:{
            bill,
        },
        data(){
            return {
                buId:"",   //bu id
                year:"",    //查询 年
                cycleId:"",  //查询 快币id

                data:"",   //获取的数据
                bonusCycleOptions:[],  //联动 周期序号列表
                
                bill_data:{},  //结算单数据
                bill_index:'',  //结算单tab序号

            }
        },
        computed:{
            ...mapState(["bu_list"]),
            ...mapGetters(["bonusYearOptions"]),
            datalist(){
                return this.data.list;
            },
            // title(){
            //     return `预算充值--${}`
            // },
        },

        watch:{
            year(year){
                this.bonusCycleOptions = getBonusCycleOptions(year);
                this.cycleId = "";
            },
        },

        created(){
            // this.getData();
            this.$func.getBuList(true,list=>{
                this.buId = list[0] && list[0].id;
            });
            this.$func.getBonusCycle(true);  //拿周期数据
        },
        methods:{
            getData(obj = {}){
                let url = `api/admin/personal/summary/list`;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });        
            },
            changeBu(id){
                let obj = {
                    bu_id:id,
                };
                this.year = "";
                this.bill_index = "";
                this.getData(obj);
            },
            search(page){
                let obj = {
                    bu_id:this.buId,
                    page:page,
                    cycle_year:this.year,
                    cycle_detail_id:this.cycleId,
                }
                this.getData(obj);
            },
            downloadExcel(){  //导出excel
                console.log("导出excel");
            },
            showBill(item,index){  //获取账单
                if(this.bill_index === index){
                    this.bill_index = '';
                }else{
                    let url =`api/admin/curr_personal_detail/${item.id}`;
                    this.$http.get(url,{
                        params:{
                            // user_id:this.id,
                            cycle_detail_id:item.cycle_detail_id,
                        }
                    }).then(res=>{
                        if(res.status ==200){
                            this.bill_data = res.res_data;
                            this.bill_index = index;
                        }
                    })
                }
            },
            // link(item){
            //     this.$router.push({
            //         name:'back-finance-settleDetail',
            //         query:{
            //             cycleId:item.cycle_id,
            //             id:item.id,
            //         }
            //     });
            // },
        },
        // beforeRouteLeave(to,from,next){  //离开页面之前
		// 	let res = this.$form.leave({name:'',path:to.path});
		// 	next(res);
		// },
    }
</script>

<style lang="less" scoped>
    .table{
        transition: 0.5s;
        overflow: hidden;
        max-height:0;
        &.active{
            max-height:1000px;
        }
    }
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 14%;
        }
        >div:nth-of-type(2){
            width: 20%;
        }
        >div:nth-of-type(3){
            width: 14%;
        }
        >div:nth-of-type(4){
            width: 14%;
        }
        >div:nth-of-type(5){
            width: 14%;
        }
        >div:nth-of-type(6){
            width: 14%;
        }
        >div:last-of-type{
            width: 10%;
            span{
                cursor: pointer;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-settle-list.vue?0b4404b3